var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarningIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.831 11.2358C17.5626 11.2358 19.775 9.02334 19.775 6.29178C19.775 3.56022 17.5626 1.34778 14.831 1.34778C12.0995 1.34778 9.88703 3.56022 9.88703 6.29178C9.88703 9.02334 12.0995 11.2358 14.831 11.2358ZM14.831 3.81978C16.1906 3.81978 17.303 4.93218 17.303 6.29178C17.303 7.65138 16.1906 8.76378 14.831 8.76378C13.4714 8.76378 12.359 7.65138 12.359 6.29178C12.359 4.93218 13.4714 3.81978 14.831 3.81978ZM14.831 14.3876C11.9141 11.6684 8.00831 9.99978 3.70703 9.99978V23.5958C8.00831 23.5958 11.9141 25.2644 14.831 27.9836C17.748 25.2767 21.6538 23.5958 25.955 23.5958V9.99978C21.6538 9.99978 17.748 11.6684 14.831 14.3876ZM23.483 21.2845C20.356 21.7047 17.3896 22.8913 14.831 24.77C12.2849 22.8913 9.30611 21.6923 6.17903 21.2721V12.6819C8.77463 13.1516 11.1848 14.3505 13.1501 16.1798L14.831 17.7619L16.512 16.1921C18.4772 14.3629 20.8874 13.1639 23.483 12.6943V21.2845V21.2845Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningIconDark);
export default __webpack_public_path__ + "static/media/EarningIconDark.7a5f881ad6b6c15f0ccc52aea0560189.svg";
export { ForwardRef as ReactComponent };